import { createSingleEntityStore } from '@core/ngrx-legacy';

import type { InterviewEventCounterParams, InterviewEventsCounters } from '../types';

const { actions, selectors, reducer, namespace } =
  createSingleEntityStore<InterviewEventsCounters>()('InterviewCounters', {
    customActions: adapter => ({
      fetch: (state, payload: { params: InterviewEventCounterParams }) =>
        adapter.markAsPending(state),
    }),
  });

export {
  actions as InterviewCountersActions,
  selectors as InterviewCountersSelectors,
  reducer as InterviewCountersReducer,
  namespace as InterviewCountersNamespace,
};
